import {
  OwnerPaymentListActionTypes,
  OWNER_PAYMENT_LIST_FAIL,
  OWNER_PAYMENT_LIST_LOADING,
  OWNER_PAYMENT_LIST_SUCCESS,
  OwnerPaymentListState,
  OWNER_PAYMENT_LIST_API_MSG,
  OWNER_PAYMENT_LIST_API_RES,
} from "./ActionTypes";
import { OwnerPaymentListResponse } from "./Model";

const initialStateEditPosts: OwnerPaymentListState = {
  loading: false,
  ownerPaymentListResponse: {} as OwnerPaymentListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getPaymentListByOwnerReducer = (
  state = initialStateEditPosts,
  action: OwnerPaymentListActionTypes
): OwnerPaymentListState => {
  switch (action.type) {
    case OWNER_PAYMENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case OWNER_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        ownerPaymentListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case OWNER_PAYMENT_LIST_FAIL:
      return {
        ...state,
        ownerPaymentListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case OWNER_PAYMENT_LIST_API_MSG:
      return {
        ...state,
        ownerPaymentListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case OWNER_PAYMENT_LIST_API_RES:
      return {
        ...state,
        ownerPaymentListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
